import React, {useEffect, useRef} from "react";
import {ReactComponent as BrowserHeader} from "../../Assets/browser-header.svg";


const UseCaseVideo = ({videoUrl}) => {

    let loomDiv = {
        position: 'relative',
        paddingBottom: '56.25%', /* 16:9 aspect ratio */
    }

    let loomIFrame = {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%'
    }

    return (
        <div id="demo" className="z-10 pb-0 md:pb-[3.2rem] relative">
            <div className="container bg-white flex flex-col items-center justify-end">
                <div className="relative z-[1]">
                    {/* <img className='z-[1] relative translate-y-[0%] md:translate-y-[-5%]' src={dashboardSrc} height={'855.18rem'} width={'1299rem'} alt="dashboard" /> */}
                    <div className="translate-y-[0%] md:translate-y-[-7%]">
                        <BrowserHeader className="w-full h-full"/>

                        <div style={loomDiv}>
                            <iframe
                                src={videoUrl}
                                webkitallowfullscreen mozallowfullscreen allowFullScreen
                                style={loomIFrame}>
                            </iframe>
                        </div>

                    </div>

                    {/* <img className='hidden md:block absolute top-0 right-0 z-[0] translate-y-[-50%] md:translate-y-[-50%] md:translate-x-[-0%] xl:translate-x-[-15%] xl:translate-y-[-48%] px-[30px] md:px-[0px] md:scale-[0.6] lg:scale-[0.8] xl:scale-100' src={cartSrc} width={'397.7rem'} height={'496rem'} alt="cart" /> */}
                </div>
            </div>
        </div>
    );
};

export default UseCaseVideo;
